export default "__VITE_ASSET__b254c40d__"